import React, { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, IPublicationsAction, IPublicationsState, initialState, publicationsReducer } from './publications-reducer';

const PublicationsStateContext = createContext<IPublicationsState | undefined>(undefined);
const PublicationsDispatchContext = createContext<React.Dispatch<IPublicationsAction> | undefined>(undefined);

export function PublicationsProvider({ children }: { children: React.ReactNode }) {
    const [state, dispatch] = useReducer(publicationsReducer, initialState);

    return (
        <PublicationsStateContext.Provider value={state}>
            <PublicationsDispatchContext.Provider value={dispatch}>
                {children}
            </PublicationsDispatchContext.Provider>
        </PublicationsStateContext.Provider>
    );
}

export function usePublicationsState() {
    const context = useContext(PublicationsStateContext);
    if (context === undefined) {
        throw new Error('usePublicationsState must be used within a PublicationsProvider');
    }
    return context;
}

export function usePublicationsDispatch() {
    const context = useContext(PublicationsDispatchContext);
    if (context === undefined) {
        throw new Error('usePublicationsDispatch must be used within a PublicationsProvider');
    }
    return context;
}

export { ACTION_TYPES };
